import app from 'app';
import PictureInPictureAdapter from 'c/PictureInPictureAdapter';

app.namespace.Model.AssetModel = Backbone.Model.extend({
  '?': 'AssetModel',

  idAttribute: 'id',

  defaults: {
    score: 'UNSORTED',
    dateSelected: null, // date when user selected the asset (used for asset sorting in selected assets area)
  },

  parse: function (asset, options) {
    options = $.extend(
      {
        bucketDirectory: null, // override asset bucketDirectory
        searchDate: null,
        generateId: true,
      },
      options || {}
    );

    if (!_.isEmpty(asset) && !asset._afterParser) {
      // set id if not exist
      if (options.generateId && _.isEmpty(asset.id)) {
        asset.id = app.generateAssetId(asset);
      }

      if (options.ignoreUploadStatus && _.isObject(asset.metadata)) {
        delete asset.metadata.uploadStatus;
      }

      // FIX: #81815938 google-chrome json deserialization
      if (asset.assetEntityScores) {
        for (const key in asset.assetEntityScores) {
          if (Object.getOwnPropertyDescriptor(asset.assetEntityScores, key)) {
            if (!_.isNumber(asset.assetEntityScores[key])) {
              console.warn('Some assetEntityScores were fixed:', asset);
              asset.assetEntityScores[key] = 0.01;
            }
          }
        }
      }

      // handle missing internal complex objects
      if (_.isEmpty(asset.metadata)) {
        asset.metadata = {};
      }
      if (_.isEmpty(asset.agd)) {
        asset.agd = {};
      }
      // ZOOM backward support
      if (asset.agd.effectType === 'ZOOM') {
        asset.agd.effectType = app.imageEffectType.ZOOM_IN;
      }
      // handle urls
      app.prependHttpAcrossObject(asset);
      if (app.assetType.isVIDEO(asset) && _.isEmpty(asset.metadata.posterUrl)) {
        asset.metadata.posterUrl =
          app.getAppLocation() + app.DEFAULT.videoPoster;
      }

      // handle default score
      if (_.isEmpty(asset.score)) {
        asset.score = app.assetScore.UNSORTED;
      }

      // handle bucket family override
      if (options.bucketDirectory) {
        asset.bucketDirectory = options.bucketDirectory;
      }

      if (options.searchDate) {
        asset._searchDate = options.searchDate;
      }

      // instagram API changes dirty fix
      if (
        app.assetType.isINSTAGRAM(asset) &&
        _.isEmpty(asset.metadata.socialUserName)
      ) {
        asset.metadata.socialUserName = asset.metadata.socialUserScreenName;
        asset.metadata.socialUserProfileImageUrl =
          'https://dp4stoslb9jdl.cloudfront.net/Resources/studio/img/avatars/uploadedFile.png';
      }

      // handle custom server order
      if (options.serverSortOrder) {
        asset._serverSortOrder = options.serverSortOrder;
      }

      // handle orientation according to dimensions relation
      if (
        !_.isDefined(asset.portrait) &&
        asset.metadata.width > 0 &&
        asset.metadata.height > 0
      ) {
        asset.portrait = asset.metadata.height >= asset.metadata.width;
      }

      if (
        _.isUndefined(asset.webpageMediaTypeName) ||
        asset.webpageMediaTypeName.toLowerCase() === 'unknown'
      ) {
        asset.webpageMediaTypeName = asset.metadata.title;
      }

      if (_.isUndefined(asset.realTimePreviewChecksum)) {
        asset.realTimePreviewChecksum = null;
      }
      if (_.isUndefined(asset.realTimePreviewResultData)) {
        asset.realTimePreviewResultData = null;
      }

      const _restrictions = this._getRestrictions(asset);
      const restrict =
        this._containsRestrictions(asset.metadata.restrictions) ||
        this._containsExpirationDate(asset);

      asset._restrictions = _restrictions;
      asset.isContainsRestrictions = restrict;

      if (asset.agd.customOverlays) {
        for (const co of asset.agd.customOverlays) {
          for (const field of co.fields) {
            if (field.value === 'false') {
              field.value = false;
            }
          }
        }
      }

      asset._afterParser = true;
    }

    return asset;
  },

  initialize: function (raw, options) {
    this.options = $.extend(
      {
        ignoreUploadStatus: false,
      },
      options
    );

    if (this.collection) {
      this.task = this.collection.task;
    } else if (app.storyController.story) {
      this.task = app.storyController.story;
    }

    this._getPreviewTries = 1;
    this.set('_previewOp', null);
    // [A.Block@2015-12-31] it takes more time in dev env
    this._maxGetPreviewTries = app.rootStore.getters['user/box'].isDev()
      ? 30
      : this.isFRAGMENT()
      ? 20
      : 30;

    this.listenTo(this, 'remove', this.free);

    this._getAssetPreviewTimedExecutor = new app.namespace.Model.TimedExecutor({
      timeout: [2],
      run: this._getAssetPreviewTimedExecutor_RUN.bind(this),
    });
  },

  hasAGD: function (field) {
    if (_.isUndefined(field)) {
      return !_.isEmpty(this.get('agd'));
    } else {
      return (
        _.isObject(this.get('agd')) &&
        Object.getOwnPropertyDescriptor(this.get('agd'), field)
      );
    }
  },

  isOverlayTracks: function () {
    return (this.get('overlayTracks') || []).length > 0;
  },

  isPrdInProgress: function () {
    const previewOp = this.get('_previewOp');
    return (
      !this.get('previewResultData') &&
      previewOp &&
      /get|create/i.test(previewOp)
    );
  },

  isPrdFailed: function () {
    return this.get('_previewOp') === 'fail';
  },

  shouldPullPreview: function () {
    const prd = this.get('previewResultData');
    if (this.get('_previewOp')) {
      // preview already in process
      return false;
    } else if (
      !prd &&
      this.isFRAGMENT() &&
      this.isAGDRequireRTP() &&
      !this.isSOCIALFRAGMENT()
    ) {
      return true;
    } else if (!prd && (this.isSELECTED() || this.get('guid'))) {
      const isSocial =
        this.isFACEBOOK() || this.isINSTAGRAM() || this.isTWITTER();
      return (this.isUploadDone() && isSocial) || this.isMAP();
    } else {
      return false;
    }
  },

  getAGD: function (field) {
    const agd = this.get('agd');
    if (agd) {
      if (field) {
        return agd[field];
      } else {
        return agd;
      }
    }
  },
  setAGD: function (field, value, obj) {
    if (_.isObject(field)) {
      obj = field;
    } else if (_.isString(field)) {
      obj = {};
      obj[field] = value;
    }
    // triggers change agd
    this.set('agd', $.extend(true, {}, this.get('agd'), obj));
  },
  unsetAGD: function () {
    if (this.hasAGD()) {
      this.set('agd', {});
    }
  },
  /**
   * Shortcut to test if metadata object has specific field
   * If field os omitted then only test for metadata presence
   * @param [field] {string}
   * @return {boolean}
   */
  hasMetadata: function (field) {
    if (_.isUndefined(field)) {
      return !_.isEmpty(this.get('metadata'));
    } else {
      return (
        _.isObject(this.get('metadata')) &&
        Object.getOwnPropertyDescriptor(this.get('metadata'), field)
      );
    }
  },

  /**
   * Shortcut to get specific metadata field
   * @param field {string} required
   * @return {*}
   */
  getMetadata: function (field) {
    return this.get('metadata') && this.get('metadata')[field];
  },

  /**
   * Set concrete field in metadata object or merge other object into it
   * Should trigger metadata change event
   * @example model.setMetadata({ caption: 'Caption', title: 'Title' });
   * @example model.setMetadata('caption', 'Caption');
   * @param field {string|object} field name or object to merge
   * @param [value] {*}
   * @param [obj] internal
   */
  setMetadata: function (field, value, obj) {
    if (_.isObject(field)) {
      obj = field;
    } else if (_.isString(field)) {
      obj = {};
      obj[field] = value;
    }
    // triggers change metadata
    this.set('metadata', $.extend(true, {}, this.get('metadata'), obj));
  },

  isSELECTED: function () {
    return app.assetScore.isSELECTED(this);
  },

  /**
   * Check if asset has coordinates defined according to `effectType`
   * @return {boolean}
   */
  hasSELECTION: function () {
    const agd = this.get('agd');
    let rv = false;

    if (!_.isEmpty(agd) && app.imageEffectType.isDefined(this)) {
      // check if upper border is defined
      if (app.imageEffectType.isZOOM(this)) {
        rv = agd.zoomX1 > 0 && agd.zoomY1 > 0;
      } else if (app.imageEffectType.isCROP(this)) {
        rv = agd.cropX1 > 0 && agd.cropY1 > 0;
      }
    }

    return rv;
  },

  hasVideoContent: function () {
    return (
      app.assetType.isFRAGMENT(this) ||
      app.assetType.isGIF(this) ||
      this.has('previewResultData')
    );
  },
  isVIDEO: function () {
    return app.assetType.isVIDEO(this);
  },
  isFRAGMENT: function () {
    return app.assetType.isFRAGMENT(this);
  },
  /**
   * check if the asset not require rtp
   */
  isAGDRequireRTP: function () {
    return (
      _.chain(this.getAGD())
        .omit(['scale', 'offset', 'transition', 'videoSpeed'])
        .values()
        .reduce((a, b) => a || !_.isNull(b), false)
        .value() !== false ||
      (this.getAGD().videoSpeed && this.getAGD().videoSpeed !== 1) === true
    );
  },
  isGIF: function () {
    return app.assetType.isGIF(this);
  },
  isIMAGE: function () {
    return app.assetType.isIMAGE(this);
  },
  isWALLPAPER: function () {
    return app.assetType.isWALLPAPER(this);
  },
  isWEBPAGE: function () {
    return app.assetType.isWEBPAGE(this);
  },
  isSOCIAL: function () {
    return app.assetType.isSOCIAL(this);
  },
  isTWITTER: function () {
    return app.assetType.isTWITTER(this);
  },
  isFACEBOOK: function () {
    return app.assetType.isFACEBOOK(this);
  },
  isINSTAGRAM: function () {
    return app.assetType.isINSTAGRAM(this);
  },
  isSOCIALVIDEO: function () {
    return app.assetType.isSOCIALVIDEO(this);
  },
  isSOCIALIMAGE: function () {
    return app.assetType.isSOCIALIMAGE(this);
  },
  isSOCIALFRAGMENT: function () {
    return app.assetType.isSOCIALFRAGMENT(this);
  },
  isMAP: function () {
    return app.assetType.isMAP(this);
  },
  isINFOGRX: function () {
    return this.isWEBPAGE() || this.isMAP();
  },

  isUploadFailed: function () {
    return (
      this.hasMetadata('uploadStatus') &&
      this.getMetadata('uploadStatus') === app.uploadStatus.FAILED
    );
  },
  isUploadDone: function () {
    return this.getMetadata('uploadStatus') === app.uploadStatus.DONE;
  },

  isInMyGalleryCollection: function () {
    return 'asset_server' === this.getMetadata('providerId');
  },

  isCopyRighted: function () {
    return app.assetType.isCopyRighted(this);
  },

  isEffects: function () {
    return app.assetType.isEffects(this);
  },

  isExpired: function () {
    return (
      !!this.getMetadata('expirationDate') &&
      Date.now() >= this.getMetadata('expirationDate')
    );
  },

  /** @deprecated in zendive.timelineRedesign copied to RestrictionsController */
  _containsRestrictions: function (restrictions) {
    let result = false;
    if (_.isDefined(restrictions) && !_.isEmpty(restrictions.trim())) {
      result = true;
    }
    return result;
  },

  /** @deprecated in zendive.timelineRedesign copied to RestrictionsController */
  _containsExpirationDate: function (asset) {
    const expirationDate = asset.metadata.expirationDate;
    if (
      _.isUndefined(expirationDate) ||
      Object.getOwnPropertyDescriptor(
        tk.context._expirationExcludeProviders,
        asset.metadata.providerId
      )
    ) {
      return false;
    }
    // If expiration date is more than 10 years from now, it should not be displayed to the user at all.
    const deltaYears = app.moment(expirationDate).diff(app.moment(), 'years');
    return deltaYears < 10;
  },

  /** @deprecated in zendive.timelineRedesign copied to RestrictionsController */
  _getRestrictions: function (asset) {
    function formatExpirationDateMessage(expirationDate) {
      const expirationDateFormatted = app
        .moment(expirationDate)
        .format('MM/DD/YYYY');
      return app.culture.generic.EXPIRATION_DATE_RESTRICTIONS.format(
        expirationDateFormatted
      );
    }

    const expirationDate = asset.metadata.expirationDate;
    const containsRestrictions = this._containsRestrictions(
      asset.metadata.restrictions
    );
    const containsExpirationDate = this._containsExpirationDate(asset);
    const isEditorial = app.assetType.isEditorial(asset);
    const isCommercial = app.assetType.isCommercial(asset);
    let returnString = asset.metadata.restrictions || '';

    if (app.assetType.isFairUse(asset) && !containsRestrictions) {
      returnString = app.culture.generic.FAIR_USE_MESSAGE;
    } else if (containsRestrictions) {
      if (containsExpirationDate) {
        returnString += '<br>' + formatExpirationDateMessage(expirationDate);
      }
    } else if (containsExpirationDate) {
      returnString = formatExpirationDateMessage(expirationDate);
    }

    if (isEditorial) {
      returnString +=
        (!_.isEmpty(returnString) ? ' - ' : '') +
        app.culture.generic.FOR_EDITORIAL_USE;
    } else if (isCommercial) {
      returnString +=
        (!_.isEmpty(returnString) ? ' - ' : '') +
        app.culture.generic.FOR_COMMERCIAL_USE;
    }

    return returnString;
  },

  createOriginalVideo: function () {
    if (!this.isFRAGMENT()) {
      return null;
    }

    let newAssetType = 'VIDEO';
    let newType = app.assetType.VIDEO;
    if (this.isSOCIALFRAGMENT()) {
      newAssetType = this.getMetadata('assetType');
      newType = app.assetType.SOCIAL;
    }

    const clone = $.extend(true, {}, this.attributes, {
      // overwrite
      id: this.getMetadata('assetUUID'),
      type: newType,
      score: app.assetScore.UNSORTED,
      agd: {}, // reset
      metadata: {
        assetType: newAssetType,
        uploadStatus: null,
      },
    });
    const newVideo = _.omit(clone, [
      // omit fragment relevant data
      'previewResultData',
      'realTimePreviewResultData',
      'realTimePreviewChecksum',
      'thumbnail',
      '_exactDuration',
      '_previewOp',
      // omit timeline relevant data
      PictureInPictureAdapter.TRACK_PROP,
      'displayStartTime',
      'displayDuration',
      'displayEndTime',
      '$el',
      'guid',
      'limit',
      'point',
      'anchor',
      'timespan',
    ]);

    const newVideoModel = new this.constructor(newVideo, { parse: false });
    newVideoModel.collection = this.collection;
    newVideoModel.unsetAGD();
    return newVideoModel;
  },

  isMatchesSearchCriteria: function (rgPattern) {
    const searchContent = this._getSearchContent().join('\n');
    if (!_.isEmpty(rgPattern)) {
      rgPattern = rgPattern.replace(/["']/g, '');
    }
    return (
      null == rgPattern || app.string2RegExp(rgPattern, 'i').test(searchContent)
    );
  },

  createAssetPreview: function (options) {
    // call to create server-side fragment preview
    options = $.extend({ type: app.RealtimePreviewType.VIDEO }, options);
    this.set({
      previewResultData: null,
      _previewOp: 'create',
      _previewStartTime: new Date().getTime(),
    });
    if (this.isSOCIAL() || this.isSOCIALFRAGMENT() || this.isINFOGRX()) {
      // real time preview
      this.fakePreviewStepsStart();

      const programmer = this.task.getProgrammer();
      const assetData = this.serialize();
      const xtraExtends = {};
      let duration = programmer.get('configInitialInfoGfxDT');

      if (this.isSOCIALFRAGMENT()) {
        duration = assetData.endTime - assetData.startTime;
        xtraExtends.volumeControl = {
          video: 1,
          bgMusic: null,
          narration: null,
        };
      }

      // prd preview should only contain crop values, if any.
      if (_.isObject(assetData.agd) && !_.isEmpty(assetData.agd)) {
        assetData.agd = _.pick(assetData.agd, ['scale', 'offset']);
      }

      const rtpPromise = app.realTimePreviewController.addTrackToPreviewQueue({
        delay: 0,
        visualTrack: $.extend(
          assetData,
          {
            displayDuration: duration,
            displayEndTime: duration,
            displayStartTime: 0,
            source: 'assetModel',
          },
          xtraExtends
        ),
        silent: false,
        type: options.type,
      });

      rtpPromise
        .then((rtpModel) => {
          if (!rtpModel) {
            return;
          }
          this.rtpModel = rtpModel;
          this.rtpModel.on('change:status change:_lastTouch', () => {
            if (rtpModel.isFailed()) {
              this.previewFetchFailed('create');
            } else if (rtpModel.isDone()) {
              const rtpResultData = rtpModel.get('realTimePreviewResultData');
              app.prependHttpAcrossObject(rtpResultData);
              if (options.type === app.RealtimePreviewType.STATIC) {
                this.set({
                  _staticPreview: rtpResultData.cdnUrl,
                });
              } else if (options.type === app.RealtimePreviewType.STATIC_MASK) {
                this.set({
                  _staticMaskPreview: rtpResultData.cdnUrl,
                });
              } else {
                rtpResultData.startTime = 0;
                rtpResultData.endTime = 6;
                this.setPreviewResultData(
                  rtpResultData,
                  rtpModel.get('realTimePreviewChecksum')
                );
              }
              this.set({ _previewOp: 'done' });
              this.fakePreviewStepsStop();
            }
          });
          if (this.rtpModel.isDone()) {
            // rtp model already cached, last touch it to trigger a change
            // ugly? ...beauty is a matter of prespective
            this.rtpModel.set('_lastTouch', Date.now());
          }
        })
        .fail(function () {
          this.previewFetchFailed('create');
        });
    } else {
      // trimming preview
      const start = this.get('startTime');
      const end = this.get('endTime');
      if (start === 0 && end === this.getMetadata('duration')) {
        const url = app.prependHttp(this.getMetadata('urlCdn'));
        const thumbnail =
          this.get('thumbnail') ||
          this.getMetadata('thumbnail256x144Url') ||
          this.getMetadata('thumbnail160x90Url') ||
          null;
        this.setPreviewResultData({
          cdnUrl: url,
          thumbnail,
        });
        this.set('_previewOp', 'done');
        return;
      }
      app.api.videoTrimming
        .post({
          url: this.getMetadata('urlCdn'),
          start,
          end,
        })
        .then((/* res*/) => {
          this._getAssetPreviewTimedExecutor.start();
        })
        .catch((res) => {
          this.previewFetchFailed('create', res);
        });
    }
  },

  fakePreviewStepsStart: function () {
    this.set('_previewStep', 0);
    this.fakePreviewStepsInterval = setInterval(() => {
      if (this.get('_previewStep') === 100) {
        return;
      }
      this.set('_previewStep', this.get('_previewStep') + 1);
    }, 750);
  },

  fakePreviewStepsStop: function () {
    clearInterval(this.fakePreviewStepsInterval);
    this.fakePreviewStepsInterval = null;
  },

  _getAssetPreviewTimedExecutor_RUN: function (loop) {
    this._getPreviewTries++;
    if (loop) {
      // shouldnt update when using RTP for preview
      this.set({
        _previewOp: 'get',
        _previewStep: this._getPreviewTries,
      });
    } else {
      // debugger; // when it called without `loop`??
    }

    app.api.videoTrimming
      .get({
        url: this.getMetadata('urlCdn'),
        start: this.get('startTime'),
        end: this.get('endTime'),
      })
      .then(
        (res) => {
          if (loop) {
            loop.reject();
          }
          app.prependHttpAcrossObject(res);
          this.setPreviewResultData(res.previewResultData);
          this.set('_previewOp', 'done');
        },
        () => {
          if (loop) {
            loop.resolve();
          }
        }
      )
      .finally((res) => {
        if (this._getPreviewTries === this._maxGetPreviewTries) {
          this.previewFetchFailed('get', res);
        }
      });
  },

  setPreviewResultData: function (previewResultData, rtpChecksum) {
    this.set({
      previewResultData: previewResultData,
    });

    if (previewResultData && !rtpChecksum) {
      if (previewResultData.thumbnail) {
        this.set('thumbnail', previewResultData.thumbnail);
      }
      app.trigger('app.fragment.preview.cached', this);
    }
  },

  previewFetchFailed: function () {
    // app.doctorController.report('Failed to '+warn+' asset preview', err);
    this._getAssetPreviewTimedExecutor.isRunning() &&
      this._getAssetPreviewTimedExecutor.stop();
    this.fakePreviewStepsStop();
    this.set({
      previewResultData: null,
      _previewOp: 'fail',
    });
  },

  free: function () {
    this.stopListening();
    this._freePreviewGenerate();
  },

  _freePreviewGenerate: function () {
    if (this._getAssetPreviewTimedExecutor.isRunning()) {
      this._getAssetPreviewTimedExecutor.stop();
      console.log('stopping assetmodel preview time executor');
    }

    if (this.rtpModel && !this.rtpModel.isDone()) {
      app.realTimePreviewController.abortRTP(
        this.rtpModel.get('realTimePreviewChecksum')
      );
    }

    this.set({
      previewResultData: null,
      _previewOp: null,
    });
  },

  destroy: function () {
    const promise = $.Deferred(); // [A.Block@20140715] should be always resolved, do not reject
    if (_.isEmpty(this.getMetadata('assetUUID'))) {
      promise.resolve({
        error: 'Trying to send DELETE request for unknown asset',
        model: this,
      });
      return;
    }
    if (!this.isInMyGalleryCollection()) {
      console.error(
        'current implementation supports my gallery private assets removal only'
      );
      promise.resolve({
        error: 'Feature not implemented. Only private assets can be destroyed.',
        model: this,
      });
    } else {
      $.ajax({
        url: app.apiUrl(
          '/api/v1/assets/' + this.getMetadata('assetUUID') + '?_=' + $.now()
        ),
        async: true,
        method: 'DELETE',
        error: $.proxy(function (jqXHR, textStatus, errorThrown) {
          promise.resolve({
            error: errorThrown,
            model: this,
          });
        }, this),
        success: $.proxy(function (response) {
          promise.resolve({
            error: response.response !== 'OK' && response.response,
            model: this,
          });
        }, this),
      });
    }

    return promise;
  },

  /**
   * Strip auto-generated properties from given object
   * It doesn't operates on this but on argument, so can be used as static.
   * @static
   * @param obj IN/OUT {AssetModel.attributes Object}
   * @return same as argument (for convenience)
   */
  strip: function (obj) {
    const omitKey = [
      'timespan',
      'limit',
      'point',
      'guid',
      'portrait',
      'originalEvent',
    ];

    _.map(obj, function (value, key) {
      if (/^[_|$]/.test(key) || _.includes(omitKey, key)) {
        obj[key] = null;
        delete obj[key];
      }
    });

    return obj;
  },

  cloneAttributes: function () {
    return _.cloneDeepAndClean(this.attributes);
  },

  /**
   * called while serialization that is called while sending assets to server to save
   */
  serialize: function () {
    return this.strip(this.cloneAttributes());
  },

  fetchInstagramProfile: function () {
    const promise = $.Deferred();
    if (!this.isINSTAGRAM()) {
      promise.resolve();
    } else {
      if (this.get('_instagramProfileFetched')) {
        promise.resolve();
      } else {
        this.set('_instagramProfileFetching', true);
        app.api.instagramExt
          .getUser({
            query: this.getMetadata('socialUserScreenName'),
          })
          .then(
            (user) => {
              this.set('_instagramProfileFetching', false);
              this.set('_instagramProfileFetched', true);
              this.setMetadata({
                socialUserName: user.full_name,
                socialUserProfileImageUrl: user.profile_pic_url,
              });
              promise.resolve();
            },
            () => {
              // failed
              this.set('_instagramProfileFetching', false);
              this.set('_instagramProfileFetched', true);
              promise.resolve();
            }
          );
      }
    }
    return promise;
  },
});

export default app.namespace.Model.AssetModel;
